import clsx from 'clsx'
import type { PropsWithChildren, ReactNode } from 'react'
import React from 'react'
import { useId } from '../hooks/useId'
import Typography from '../Typography/Typography'

interface GroupProps {
  label?: ReactNode
}

function Group({
  children,
  label = null,
}: PropsWithChildren<GroupProps>): JSX.Element {
  const id = `coconut-menu-group-label-${useId()}`

  return (
    <li
      className={clsx(
        'border-b border-black-10 last:border-b-0 py-4 last:pb-0 first:pt-0',
        label ? 'pt-4' : '',
      )}
    >
      {label ? (
        <span className="px-5 pb-2 whitespace-no-wrap text-black-60" id={id}>
          <Typography color="inherit" variant="subtitle3">
            {label}
          </Typography>
        </span>
      ) : null}
      <ul aria-labelledby={label ? id : undefined} role="group">
        {children}
      </ul>
    </li>
  )
}

export default Group
